import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/shopDataApi'

class Store {
  @observable overviewTab = '0'
  @observable trendTab = '7'
  @observable typeTab = '1'

  @observable sourceTab = '7'

  @action
  changValue = type => e => {
    this[type] = e.target.value

    if (type == 'overviewTab') {
      this.getOverview()
    }

    if (type == 'trendTab') {
      this.getTrend()
    }

    if (type == 'sourceTab') {
      this.getSource()
    }
  }

  @action
  changField = value => {
    this.typeTab = value
    this.getTrend()
  }

  @observable overview = {}
  @action
  getOverview = async () => {
    const timeArray = ['1', '7', '30', '60']
    const { overviewTab } = this
    let { data, success } = await Api.overview({
      days: timeArray[overviewTab],
      from: 'shopData'
    })
    if (success) {
      runInAction(() => {
        this.overview = data || {}
      })
    } else {
      this.overview = {}
    }
  }

  @observable trend = []
  @action
  getTrend = async () => {
    const { trendTab, typeTab } = this
    let {
      data: { list },
      success
    } = await Api.trend({ days: trendTab, tab: typeTab })
    if (success) {
      runInAction(() => {
        this.trend = list || []
      })
    }
  }

  @observable source = []
  @action
  getSource = async () => {
    const { sourceTab } = this
    let {
      data: { list },
      success
    } = await Api.source({ days: sourceTab })
    if (success) {
      runInAction(() => {
        this.source = list || []
      })
    } else {
      this.source = []
    }
  }
}
export default Store
